import { Injectable } from '@angular/core';

@Injectable()
export class UploadFileService {
  public append(payload: FormData, file: File | Blob, payloadName = 'file'): void {
    if (file instanceof Blob && !(file instanceof File)) {
      file = new File([file], (file as any).name, { type: file.type, lastModified: Date.now() });
    }

    payload.append(payloadName, file);
  }
}
